module.exports = __webpack_public_path__ + "img/meshnet.f98bce7c.png";